<template lang="pug">
.page-head__wrap.full__width(
  v-if='game || isAllGames',
  :style='{ backgroundImage: backgroundImage }'
)
  InfoMessage.page-head__warning(v-if='headWarning', type='warning') {{ headWarning.text }}
  .page-head(
    :class='[`--${tournament ? `state-${tournament.state}` : "list"}`, { "--tournament": isSingleEvent }]'
  )
    .page-head__effect
    .page-head__top
      .container.page-head__top-details
        .page-head__top-actions
          AddToCalendar(
            v-if='isSingleEvent && tournament.state === "open"',
            :tournament='tournament'
          )
          SocialShare(:direction='isSingleEvent ? "down" : "left"')

    .div
      .page-head__info.container(:class='{ "--all__games": isAllGames }')
        .page-head__info-wrap
          .page-head__title-wrapper
            .page-head__title-left
              .page-head__game(v-if='game')
                .page-head__game-gradient
                img(:src='game.extra_data.icon', :alt='game.extra_data.title')
              .page-head__date-info
                .page-head__when
                  span(v-if='isGame && game.event_count')
                    | {{ game.event_count }} {{ plural(game.event_count, "event", "events", "events") }}

                  template(v-if='isSingleEvent')
                    .page-head__state(:class='statusClass')
                      .page-head__state-top
                        img(
                          :src="require('~/assets/img/icons/status.svg')"
                          alt="status"
                        )
                        template(v-if='tournament') {{ statusText }}
                      .page-head__state-error(
                        v-if='tournament.state === "cancelled" && tournament.error'
                      ) {{ tournament.error }}
                    .page-head__state.page-head__private(
                      v-if='tournament.is_private'
                    )
                      img(:src="require('~/assets/img/icons/lock.svg')" alt="lock")
                      | {{ $t("isPrivate") }}
                    .page-head__freeroll(v-if='!isTournamentSponsored && isFreeroll') Freeroll
                    .page-head__when-date
                      client-only
                        | {{ dateText }}

              h1.page-head__title
                template(v-if='isAllGames')
                  span {{ $t("tournaments") }}
                  | &nbsp;{{ $t("forAllGames") }}
                template(v-else-if='isTournamentsList')
                  span {{ $t("tournaments") }}
                template(v-else-if='isDuelsList')
                  span {{ $t("duels") }}
                template(v-else-if='isPhasedTournamentsList')
                  span {{ $t("phasedTournaments") }}
                template(v-else-if='isTournament')
                  template(v-if="isTournamentSponsored")
                    | {{ tournament.title }}
                  template(v-else)
                    | {{ tournament.title }}
                  span.page-head__title-id(v-tippy :content="$t('copyInput')" @click="copyText(tournament.id)") \#{{ tournament.id }}
                template(v-else-if='isGame')
                  | {{ game.extra_data.full_title }}
                template(v-else-if='isPhasedTournament')
                  template(v-if="isTournamentSponsored")
                    | {{ tournament.title }}
                  template(v-else)
                    | {{ tournament.title }}

                template(v-if='isList && !isAllGames')
                  | &nbsp;{{ $t("timeAt") }} {{ game.extra_data.full_title }}

            .page-head__title-right
              .page-head__time-wrap(
                v-if='tournament && tournament.state === "open" && isCounterVisible'
              )
                .page-head__time-state {{ $t("timerStartsIn") }}
                .page-head__time
                  client-only
                    Countdown(:end-time='startsAt')
                      span(slot='process', slot-scope='{ timeObj }')
                        | {{ timeObj.h }}:{{ timeObj.m }}:{{ timeObj.s }}

              .page-head__game-account(
                v-if='(isGame || isList) && currentGameAccount'
              )
                .page-head__game-account-title {{ $t("accountInGame") }}
                .page-head__game-account-value
                  PlayerGameName(:account='currentGameAccount', :game='game')
                  .page-head__game-account-rating(
                    v-if='currentGameAccount.ratings.default'
                  )
                    RatingTooltip
                      img(:src='require(`~/assets/img/icons/new-rating.svg`)')
                      | {{ Math.floor(currentGameAccount.ratings.default) }}

              Breadcrumbs(:list='breadcrumbs')

              .page-head__buttons(
                v-if='isTournament || isPhasedTournament'
              )
                Button(
                  v-if='["cancelled", "completed"].includes(tournament.state)',
                  is-secondary,
                  @click='localeLocation($router.push($route.path.split("/").slice(0, -1).join("/")))'
                )
                  | {{ $t('findAnotherTournament') }}

                Button(
                  v-else-if="tournament.teams && canTeamJoinTournament && regStarted && isTeamCaptain",
                  is-primary,
                  @click='joinTournamentAsTeam'
                ) {{ $t('joinAsTeam', { teamName: team && team.name }) }}

                Button(
                  v-else-if='!isFreerollBlocked && canJoinTournament && !hasAccess && regStarted && !needToWaitTeamToJoin',
                  is-primary,
                  @click='onJoinTournamentClick()'
                  :is-disabled="!is24Finished"
                ) {{ $t('join') }}

                Button(
                  v-else-if='isTeamNeeded',
                  is-primary,
                  @click='openCreateTeamModal'
                ) {{ $t('assembleTeam') }}

                Button(
                  v-else-if="areTournamentResultsNeeded",
                  is-primary
                  @click='onSendTournamentResultsClick'
                ) {{ $t('sendTournamentResults') }}

                //StreamButtons(:tournament="tournament" :game-name="game.name")

              .page-head__buttons(v-if="showDuelButton")
                Button(is-primary, @click='onCreateDuelClick') {{ $t('buttonCreateDuel') }}

      .page-head__footer
        .container
          .page-head__params(v-if='tournament')
            Component.page-head__param(
              v-for='(param, index) in params',
              :key='index',
              :is='param.component || "div"',
              is-vertical
            )
              .page-head__param-icon
                img(:src='param.icon', :alt='param.icon', width='32', height='32')
                .page-head__param-bonus(v-if='param.bonus') -{{ param.bonus }}%
              .page-head__param-info
                .page-head__param-value(v-if='param.currency && param.value')
                  Currency(
                    :type='param.currency',
                    :class='{ "--discount": param.bonus }',
                    size='20'
                  )
                    | {{ param.value }}
                  template(v-if="param.currency === 'coins'")
                    | &nbsp;+&nbsp;
                    Currency(type="tickets" is-reversed)
                      span.card-tournament__body-pair-value {{ tournamentTrophyPrize }}
                  i(v-if='param.isNotFixedPrizePool && maxPrizePool')
                    | {{ $t("max") }} {{ formatNumber(maxPrizePool) }}
                .page-head__param-value(
                  v-else,
                  :class='param.isGame ? `--game-${game.name}` : ""',
                  v-html='param.value'
                )

                .page-head__param-title {{ param.title }}

              template(v-slot:tooltip)
                .page-head__entry-fee-tooltip(v-if='param.tickets')
                  strong {{ $t("whatFormsEntryFee") }}
                  div(
                    v-html='$t("contributionInPrizePool", { fee: formatNumber(entryFeeMinusCommission) })'
                  )
                  div(
                    v-html='$t("contributionInEntryFee", { fee: formatNumber(commission) })'
                  )

                .page-head__entry-fee-tooltip.page-head__entry-fee-tooltip--prize(
                  v-else-if='param.isNotFixedPrizePool'
                )
                  div {{ $t("maxPrizePool") }}&nbsp;
                    Currency(:type='param.currency', size='20') {{ formatNumber(maxPrizePool) }}
                  div {{ $t("achievedWithMaximumNumberOfRegs") }}

          .page-head__menu-wraper(v-if='isList || isGame || isAllGames' :class='{ "--all__games": isAllGames }')
            Tabs(
              :items='tabs',
              :active-tab-index='activeTabIndex',
              @change='onTabChange'
            )
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { getPrizePool, copyText } from '~/utils/utils'
import TournamentMixin from '~/mixins/Tournament'
import Tabs from '~/components/Tabs/Tabs'
import SocialShare from '~/components/SocialShare/SocialShare'
import Breadcrumbs from '~/components/Breadcrumbs/Breadcrumbs'
import PlayerGameName from '~/components/PlayerGameName/PlayerGameName'
import VideoChatButton from '~/components/VideoChatButton/VideoChatButton'
import AddToCalendar from '~/components/AddToCalendar/AddToCalendar'
import Tooltip from '~/components/Tooltip/Tooltip'
import RatingTooltip from '~/components/RatingTooltip/RatingTooltip'

export default {
  name: 'PageHead',

  components: {
    Tooltip,
    AddToCalendar,
    VideoChatButton,
    PlayerGameName,
    Breadcrumbs,
    Tabs,
    SocialShare,
    RatingTooltip
  },

  mixins: [TournamentMixin],

  props: {
    tournament: {
      type: Object,
      default: null
    },

    duel: {
      type: Object,
      default: null
    }
  },

  data () {
    const isDuelsList = this.$route.name.startsWith('game-duels_')
    const isDuel = this.$route.name.startsWith('game-duels-id_')
    const isTournamentsList = this.$route.name.startsWith('game-tournaments_')
    const isTournament = this.$route.name.startsWith('game-tournaments-id_')
    const isGame = this.$route.name.startsWith('game_')
    const isPhasedTournamentsList = this.$route.name.startsWith(
      'game-phased-tournaments_'
    )
    const isPhasedTournament = this.$route.name.startsWith(
      'game-phased-tournaments-id_'
    )
    const isAllGames = this.$route.name.startsWith('tournaments_')

    return {
      isGame,
      isDuelsList,
      isDuel,
      isTournamentsList,
      isTournament,
      isAllGames,
      isPhasedTournamentsList,
      isPhasedTournament,
      copyText,
      currencies: []
    }
  },

  computed: {
    ...mapState('games', ['gamesByName']),
    ...mapState('user', ['user', 'freerollCount']),
    ...mapGetters('user', ['isAuthorized', 'currency']),
    ...mapGetters('global', ['getPlatformRemoteFeatures']),

    showDuelButton () {
      return this.isDuelsList && !this.game.hasTournamentsAsDuels
    },

    showFreerollCount () {
      if (!this.isAuthorized || this.hasFreerollSubscriprion) {
        return false
      }

      return this.freerollCount >= 0
    },

    isShowIntegration () {
      return this.getPlatformRemoteFeatures?.sovcombank
    },

    showTelegramButton () {
      const gamesWithTelegram = ['lichess', 'free-fire']
      return gamesWithTelegram.includes(this.game.name)
    },

    breadcrumbs () {
      const breadcrumbs = []
      if (this.isAllGames) {
        breadcrumbs.push({
          title: this.$t('allTournaments')
        })
      } else {
        breadcrumbs.push({
          title: this.game.extra_data.title,
          to: this.isGame ? null : `/${this.game.name}`
        })
      }
      if (this.isDuelsList || this.isDuel) {
        breadcrumbs.push({
          title: this.$t('duels'),
          to: this.isDuel ? `/${this.game.name}/duels` : null
        })
      }
      if (this.isTournamentsList || this.isTournament) {
        breadcrumbs.push({
          title: `${this.$t('tournaments')} ${this.game.name}`,
          to: this.isTournament ? `/${this.game.name}/tournaments` : null
        })
      }
      if (this.isPhasedTournamentsList || this.isPhasedTournament) {
        breadcrumbs.push({
          title: this.$t('phasedTournaments'),
          to: this.isPhasedTournament
            ? `/${this.game.name}/phased-tournaments`
            : null
        })
      }
      if (this.isTournament || this.isPhasedTournament) {
        breadcrumbs.push({ title: this.tournament.title })
      }
      if (this.isDuel) {
        breadcrumbs.push({ title: this.duel.title })
      }
      return breadcrumbs
    },

    params () {
      const params = []

      params.push({
        icon: require('~/assets/img/icons/new-rating.svg'),
        title: this.$t('rating'),
        value: this.getRatingText(),
        component: 'RatingTooltip'
      })

      if (this.tournament.prize_settings?.entry_fee_currency === 'coins' && this.tournament.entry_fee > 0) {
        params.push({
          icon: require('~/assets/img/icons/cost.svg'),
          title: this.$t('entryFee'),
          value: 'VVV Pass',
          component: 'div'
        })
      } else if (this.tournament.prize_settings?.prize_currency === 'money' && this.tournament.entry_fee === 0) {
        params.push({
          icon: require('~/assets/img/icons/cost.svg'),
          title: this.$t('entryFee'),
          value: 'Free',
          component: 'div'
        })
      } else {
        params.push({
          icon: require('~/assets/img/icons/cost.svg'),
          title: this.$t('entryFee'),
          value: this.formatNumber(this.bonus?.value || this.entryFee),
          currency: this.tournament.prize_settings?.entry_fee_currency,
          tickets: this.isPaid ? this.ticketsPrice : null,
          component: this.isPaid ? 'Tooltip' : 'div',
          bonus: this.bonus?.percents,
          crossed: this.bonus ? this.formatNumber(this.entryFee) : null
        })
      }

      let prizeIcon = require('~/assets/img/icons/trophy.svg')
      let prizeTitle = this.$t('prizePool')
      let prizeValue = this.formatNumber(getPrizePool(this.tournament))
      let isNotFixedPrizePool = [
        'not_fixed_with_guarantee',
        'not_fixed'
      ].includes(this.tournament.prize_settings?.prize_pool_type)

      if (this.isDoublePrize) {
        prizeIcon = require('~/assets/img/icons/x2.svg')
        prizeTitle = this.$t('prizeWinnerReward')
        prizeValue = this.formatNumber(this.doublePrize)
        isNotFixedPrizePool = false
      } else if (this.tournament.prize_settings?.prize_pool_type === 'fixed') {
        prizeIcon = require('~/assets/img/icons/fixed.svg')
        prizeTitle = this.$t('constantPrizePoolShort')
      } else if (isNotFixedPrizePool) {
        prizeIcon = require('~/assets/img/icons/not-fixed.svg')
        prizeTitle = this.$t('risingPrizePoolShort')
      }

      params.push({
        id: 'prize',
        icon: prizeIcon,
        title: prizeTitle,
        value: prizeValue,
        currency: this.tournament.prize_settings?.prize_currency,
        isNotFixedPrizePool,
        component: isNotFixedPrizePool ? 'Tooltip' : 'div'
      })

      if (this.tournament.prize_settings?.nominations?.length) {
        params.push({
          icon: require('~/assets/img/icons/nominations.svg'),
          title: this.$t('nominations'),
          value: this.tournament.prize_settings?.nominations?.length
        })
      }

      if (this.withRewardsPoints) {
        let value

        if (!this.tournament.prizes?.point) {
          const prizePool = getPrizePool(this.tournament)

          value = this.withRewardsPlaces ? prizePool / 2 : prizePool
        } else {
          value =
            this.tournament.prize_settings?.prize_currency === 'money'
              ? this.tournament.prizes?.point / 100
              : this.tournament.prizes?.point

          value = this.formatNumber(value)
        }

        params.push({
          icon: require('~/assets/img/icons/target.svg'),
          title: this.$t('rewardForKill'),
          value,
          currency: this.tournament.prize_settings?.prize_currency
        })
      }

      if (
        this.tournament.prize_settings?.place_distribution_type !== 'point' &&
        ['top', 'percentage'].includes(
          this.tournament.prize_settings?.prize_winner_type
        )
      ) {
        const prizes = {
          icon: require('~/assets/img/icons/star-with-paddings.svg'),
          title: this.$t('numberOfWinners')
        }
        const placesCount = this.tournament.prize_settings.win_place_count

        if (this.tournament.prize_settings.prize_winner_type === 'top') {
          prizes.value = this.$t('places', { count: placesCount })
        } else if (
          this.tournament.prize_settings.prize_winner_type === 'percentage'
        ) {
          prizes.value = this.$t('percentFromPlayers', {
            percentage: placesCount
          })

          const prizesCount = this.tournament?.prizes?.places?.length

          if (prizesCount > 0) {
            const text = this.$t('places', { count: prizesCount })

            prizes.value += `<i>${text}</i>`
          }
        }

        params.push(prizes)
      }

      return params
    },

    canShowIntegration () {
      return (
        this.isTournamentSponsored ||
        (this.isShowIntegration &&
          this.game?.name === 'pubg-mobile' &&
          !this.isTournament &&
          !this.isDuelsList &&
          !this.isPhasedTournament)
      )
    },

    tournamentTrophyPrize () {
      return Math.ceil(this.tournament?.prize_pool / 1000).toFixed(0)
    },

    backgroundImage () {
      return ''
    },

    image () {
      if (this.game?.extra_data?.image_url) {
        return `url(${this.game.extra_data.image_url})`
      }

      return 'url(https://cdn.gaming-goods.com/images/games/all-games.png)'
    },

    tabs () {
      if (this.isAllGames) {
        return [
          {
            title: this.$t('allTournaments'),
            link: '/tournaments'
          }
        ]
      }

      const tabs = []

      tabs.push({
        title: this.$t('overview'),
        link: `/${this.game.name}`
      })

      if (this.game.is_tournament_enabled) {
        tabs.push({
          title: this.$t('tournaments'),
          link: `/${this.game.name}/tournaments`
        })
      }

      if (this.game.is_duel_enabled) {
        if (this.game.hasTournamentsAsDuels) {
          tabs.push({
            title: this.$t('tdm'),
            link: `/${this.game.name}/duels`
          })
        } else {
          tabs.push({
            title: this.$t('duels'),
            link: `/${this.game.name}/duels`
          })
        }
      }

      if (this.game.is_mega_tournament_enabled) {
        tabs.push({
          id: 'phased',
          title: this.$t('phasedTournaments'),
          link: `/${this.game.name}/phased-tournaments`
        })
      }

      /* if (this.game.name === 'pubg-mobile') {
        tabs.push({
          title: this.$t('vvvTournaments'),
          link: `/${this.game.name}/tournaments?sponsor=vvv`
        })
      } */

      if (this.game.name === 'standoff') {
        tabs.push({
          title: this.$t('skaTournaments'),
          link: `/${this.game.name}/tournaments?sponsor=ska`
        })
      }

      return tabs
    },

    currentGameAccount () {
      return this.gameAccount(this.game.name)
    },

    statusClass () {
      const state = this.duel?.state || this.tournament?.state

      return {
        'page-head__state--opened': state === 'open',
        'page-head__state--closed': ['completed', 'cancelled'].includes(state),
        'page-head__state--started': state === 'in_progress'
      }
    },

    isList () {
      return (
        this.isDuelsList ||
        this.isTournamentsList ||
        this.isPhasedTournamentsList
      )
    },

    isSingleEvent () {
      return this.isDuel || this.isTournament || this.isPhasedTournament
    },

    activeTabIndex () {
      return this.tabs.findIndex(tab => tab.link === this.$route.path)
    },

    isAnticheatRequired () {
      return (
        !this.isAllGames &&
        this.isAuthorized &&
        this.game.name === 'lichess' &&
        this.$device.isWindows
      )
    },

    mobileGradientStyle () {
      const color = this.game?.color || '#fff'
      return {
        backgroundImage: `linear-gradient(160deg, ${color} 15%, rgba(28,39,53, 0) 30%), linear-gradient(-20deg, ${color} 15%, rgba(28,39,53, 0) 30%)`
      }
    },

    gradientStyle () {
      const color = this.game?.color || '#fff'

      return {
        backgroundImage: `linear-gradient(135deg, ${color} 15%, rgba(28,39,53, 0) 30%), linear-gradient(-45deg, ${color} 15%, rgba(28,39,53, 0) 30%)`
      }
    }
  },

  mounted () {
    if (
      this.isSingleEvent &&
      this.user &&
      this.tournament?.state === 'open' &&
      this.isPaid
    ) {
      this.$store.dispatch('user/fetchVerification')
    }
  },

  methods: {
    ...mapActions('modal', ['showModal']),

    openAuthModal () {
      if (!this.isAuthorized) {
        this.showModal({
          component: 'Auth',
          data: {
            mode: 'register'
          }
        })
      }
    },

    goToSubscriptions () {
      this.$router.push(this.localeLocation('/store/subscriptions'))
    },

    onTabChange ({ item }) {
      if (item.link) {
        this.$router.push(this.localeLocation(item.link))
      }
    },

    plural: require('plural-ru')
  }
}
</script>

<style lang="scss">
.full__width {
  @media (min-width: 1500px) {
    margin-left: calc(-100vw / 2 + 1500px / 2 + 40px);
    margin-right: calc(-100vw / 2 + 1500px / 2);
    width: calc(100vw - 65px) !important;
  }
}

.container {
  width: 100%;
  max-width: calc(1500px - 65px);
  margin: auto;
}

.page-head__top-details {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;

  @media (min-width: $breakpointMobile) {
    padding-right: 72px;
  }
}

.page-head__menu-wraper {
  @media (min-width: $breakpointDesktop) {
    margin-left: 40px;
  }
}

.page-head__menu-wraper.--all__games {
  margin-left: -120px;
}

.page-head {
  width: 100%;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &__game {
    position: absolute;
    width: 112px;
    height: 112px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    left: 32px;
    bottom: 24px;

    &-title {
      @include hint-small;

      @media (max-width: $breakpointDesktop) {
        display: none;
      }
    }

    img {
      width: 78px;
      height: 78px;

      @media (max-width: $breakpointDesktop) {
        margin-bottom: 0;
      }
    }

    &-gradient {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      border-radius: 50%;
      z-index: -1;

      &::before {
        content: "";
        border-radius: 50%;
        position: absolute;
        top: 1px;
        left: 1px;
        right: 1px;
        bottom: 1px;
        background-color: #222f3f;
        border: 2px solid #3a4b61b0;
      }
    }

    @media (max-width: $breakpointDesktop) {
      position: relative;
      width: 68px;
      height: 68px;
      left: 0;
      bottom: 0;
      margin-bottom: 16px;
    }

    .--list & {
      bottom: -48px;
      z-index: 3;
      width: 134px;
      height: 134px;

      img {
        width: 100px;
        height: 100px;
      }

      @media (max-width: $breakpointDesktop) {
        position: relative;
        width: 68px;
        height: 68px;
        left: 0;
        bottom: 0;
        margin-bottom: 16px;

        img {
          width: 28px;
          height: 28px;
        }
      }
    }
  }

  &__warning.info-message.--warning {
    @include hint-small;

    position: relative;
    z-index: 4;
    border-radius: 0;
    min-height: 40px;
    font-weight: 600;
    padding: 11px 11px 11px 70px;
    background: #1e88e5;
    color: #fff;

    img {
      left: 40px;
      top: 8px;

      path,
      rect {
        fill: #fff;
      }
    }

    @media (max-width: $breakpointDesktop) {
      padding-left: 46px;

      img {
        left: 16px;
      }
    }
  }

  &__entry-fee-tooltip {
    @include hint-small;

    color: #fff;

    & > strong {
      @include heading6;

      display: block;
      padding-bottom: 8px;
    }

    & > div:first-child {
      margin-bottom: 4px;
    }

    span {
      color: $blue-grey05;
    }

    &--prize {
      padding: 16px;
      line-height: 20px;

      > div {
        display: flex;
        align-items: center;

        .currency {
          @include heading5;
        }
      }
    }
  }

  .add-to-calendar {
    margin-right: 16px;
  }

  .tabs {
    margin-top: -16px;
    margin-bottom: 0;
    height: 68px;

    @keyframes shine {
      0% {
        background-position: 0;
      }

      60% {
        background-position: 211px;

        @media (max-width: $breakpointTablet) {
          background-position: 198px;
        }
      }

      100% {
        background-position: 211px;

        @media (max-width: $breakpointTablet) {
          background-position: 198px;
        }
      }
    }

    @keyframes shine-tablet {
      0% {
        background-position: 0;
      }

      60% {
        background-position: 191px;
      }

      100% {
        background-position: 191px;
      }
    }

    .--phased {
      white-space: nowrap;
    }
  }

  &__wrap {
    width: 100%;
    position: relative;
    background-size: cover;
    background-position: 56% center;

    @media (min-width: $breakpointDesktopWide) {
      height: 382px;
    }
  }

  &__effect {
    width: 100%;
    height: 100%;
    position: absolute;
    overflow: hidden;
    top: 0;
    left: 0;
    pointer-events: none;

    &::after {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      min-height: 100%;
      background:
        radial-gradient(
          50% 50% at 50% 50%,
          rgb(28 39 53 / 30%) 0%,
          rgb(28 39 53 / 50%) 100%
        );

      @media (max-width: $breakpointTablet) {
        background:
          linear-gradient(
            180deg,
            rgba($blue-grey80, 0) 0%,
            rgba($blue-grey80, 0.8) 40%,
            rgba($blue-grey80, 1) 55%
          );
      }
    }
  }

  &__title {
    @include heading1;

    color: $white;
    padding-right: 12px;
    padding-bottom: 12px;

    span {
      color: $amber60;

      &.page-head__title-id {
        font-weight: 500;
        font-size: 28px;
        line-height: 36px;
        cursor: pointer;
        color: #ffffffcf;
        padding-left: 10px;
      }
    }

    &-left {
      width: 100%;
      padding-right: 16px;
    }

    &-right {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }

    @media (max-width: $breakpointDesktop) {
      padding-bottom: 0;
    }

    .--list & {
      padding-bottom: 0;
      padding-left: 32px;

      @media (max-width: $breakpointDesktop) {
        padding-left: 0;
      }
    }
  }

  &__anticheat {
    position: absolute;
    top: 88px;
    right: 40px;
    z-index: 5;

    &.tooltip {
      position: absolute;
    }

    @media (max-width: $breakpointDesktop) {
      top: 80px;
      right: 16px;
    }
  }

  &__game-account {
    color: $white;
    z-index: 3;
    text-align: right;
    margin-top: 24px;

    &-title {
      @include caption-small;

      color: $blue-grey05;
      white-space: nowrap;

      @media (max-width: $breakpointMobile) {
        text-align: left;
      }
    }

    &-value {
      margin-top: 8px;

      .player-game-name {
        @include heading4;
      }

      @media (max-width: $breakpointTablet) {
        justify-content: flex-start;

        .player-game-name {
          width: 100%;
        }
      }
    }

    &-rating {
      @include hint-small;

      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-top: 2px;

      img {
        width: 20px;
        height: 20px;
        margin-right: 4px;
      }

      @media (max-width: $breakpointTablet) {
        justify-content: flex-start;
      }
    }
  }

  &__team {
    @include text-small;

    color: $blue-grey05;
    margin-top: 8px;
    text-align: right;
  }

  &__breadcrumbs {
    z-index: 5;
    padding-right: 88px;

    @media (max-width: $breakpointDesktop) {
      padding-right: 72px;
    }

    .--tournament.--state-open & {
      padding-right: 330px;

      @media (max-width: $breakpointMobile) {
        padding-right: 0;
      }
    }
  }

  &__time-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  &__time-state {
    @include caption-small;

    color: white;
    font-weight: 600;
    width: 100%;
    text-align: right;
    margin-bottom: 4px;
    text-shadow: 1px 1px #00000040;
  }

  &__time {
    @include heading2;

    color: $white;
    width: 100%;
    text-align: right;
    white-space: nowrap;
  }

  &__footer-max-prize {
    @include text;

    color: #fff;
    background: $blue-grey70;
    margin-top: -15px;
    margin-bottom: 14px;

    .page-head__entry-fee-tooltip--prize {
      div:first-child {
        margin: 0;
        line-height: 20px;
      }
    }
  }

  &__info {
    width: 100%;
    padding: 0 32px 24px 65px;
    position: relative;
    z-index: 4;
    left: -45px;

    @media (min-width: $breakpointDesktop) {
      padding-left: 160px;
    }

    &.--all__games {
      padding-left: 0;
    }
  }

  &__info-wrap {
    display: flex;
    width: 100%;
    flex-direction: column;
    z-index: 2;
  }

  &__date-info {
    display: flex;
    align-items: center;
  }

  &__buttons {
    display: flex;
    align-items: center;
    margin-top: 16px;

    // button + button {
    //   margin-left: 16px;
    // }

    &:empty {
      display: none;
    }
  }

  &__litres-buttons {
    width: calc(100vw - 40px);
  }

  &__buttons + &__buttons {
    margin-top: 16px;
  }

  &__when {
    @include hint-small;

    font-size: 17px;
    line-height: 20px;
    color: $white;
    display: flex;
    align-items: center;

    &-date {
      margin-left: 12px;
      margin-bottom: 8px;
      line-height: 30px;
    }
  }

  &__freeroll {
    @include hint-small;

    display: flex;
    align-items: center;
    border-radius: 8px;
    background: $black-transparent;
    backdrop-filter: blur(8px);
    height: 30px;
    padding: 0 10px;
    color: #4caf50;
    margin-left: 12px;
    margin-bottom: 8px;
  }

  &__state {
    @include hint-small;

    border-radius: 8px;
    background: $black-transparent;
    backdrop-filter: blur(8px);
    min-height: 28px;
    padding: 6px 10px 6px 8px;
    color: $white;
    position: relative;
    margin-bottom: 8px;
    line-height: 16px;

    &-top {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    &-error {
      display: block;
      color: $red60;
      margin-top: 2px;
    }

    & img {
      margin-right: 8px;
      width: 16px;
      height: 16px;
    }

    &--opened {
      svg path {
        fill: $green50;
      }
    }

    &--closed {
      svg path {
        fill: $red50;
      }
    }

    &--started {
      svg path {
        fill: $amber60;
      }
    }
  }

  &__private {
    margin-left: 12px;
    display: flex;
    flex-direction: row;
    align-items: center;

    img {
      path {
        fill: $orange60;
      }
    }
  }

  &__title-wrapper {
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  &__footer {
    min-height: 68px;
    position: relative;
    padding: 14px 0 0 25px;
    border-top: 1px solid $blue-grey50;
    border-bottom: 1px solid $blue-grey50;
    z-index: 1;

    &::before {
      content: "";
      position: absolute;
      top: -1px;
      bottom: -1px;
      left: 0;
      right: 0;
      background: $black-transparent;
      backdrop-filter: blur(24px);
      border-top: 1px solid $blue-grey50;
      border-bottom: 1px solid $blue-grey50;
    }
  }

  &__params {
    display: flex;
    height: 100%;
    align-items: center;
    flex-wrap: wrap;
    margin-left: -20px;
    margin-right: 80px;
  }

  &__param {
    display: flex;
    height: 100%;
    align-items: center;
    padding: 0 20px;
    position: relative;
    margin-bottom: 14px;

    &:first-child {
      padding-left: 0;
    }

    &-bonus {
      @include text;

      position: absolute;
      right: 0;
      bottom: -8px;
      height: 20px;
      line-height: 20px;
      color: #fff;
      background: $amber60;
      border-radius: 4px;
      transform: rotate(-4deg);
      padding: 0 3px;
    }
  }

  &__param:not(:last-child) {
    &::after {
      position: absolute;
      content: "";
      height: 32px;
      width: 0;
      border-right: 1px solid $blue-grey30;
      right: 0;
      top: 50%;
      margin-top: -16px;
    }
  }

  &__param-icon {
    min-width: 32px;
    max-width: 32px;
    height: 32px;
    margin-right: 8px;
    position: relative;

    & img {
      width: 100%;
    }
  }

  &__param-value {
    @include info-small;

    color: $white;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .currency {
      white-space: nowrap;

      &.--discount {
        color: $amber60;
      }

      img {
        margin-right: 4px;
        margin-top: -2px;
        margin-bottom: -2px;
      }
    }

    i {
      @include hint-small;

      color: $blue-grey10;
      padding-left: 4px;
      white-space: nowrap;

      &.--tickets {
        .currency {
          @include info-small;

          line-height: 21px;
          margin-left: 4px;
          color: #fff;
        }
      }
    }
  }

  &__param-title {
    @include caption-small;

    color: $blue-grey10;
    display: flex;
    align-items: center;

    img {
      margin-left: 10px;
    }
  }

  &__top-actions {
    display: flex;
    width: auto;
    z-index: 6;
  }

  &.--list .page-head__footer {
    padding-left: 171px;
  }

  &.--list .page-head__when {
    padding-left: 32px;
  }

  @media (max-width: $breakpointDesktop) {
    &__footer {
      padding-left: 10px;
      padding-right: 0;
    }

    &.--list .page-head__footer {
      padding-left: 0;
      padding-right: 0;
    }

    &.--list .page-head__when {
      padding-left: 0;
    }

    &__footer-image {
      display: none;
    }

    &__game-account {
      &-value {
        margin-top: 8px;
      }
    }

    &__breadcrumbs.breadcrumbs {
      top: 16px;
      left: 16px;
    }

    &__top-actions {
      top: 16px;
      right: 16px;
    }
  }

  @media (max-width: $breakpointTablet) {
    &__param-bonus {
      bottom: -12px;
    }

    &__time-wrap {
      display: none;
    }

    &__title-wrapper {
      flex-direction: column;
      align-items: flex-start;
    }

    &__title-right {
      position: relative;
      align-items: flex-start;
    }

    &__team {
      text-align: left;
    }

    &__footer {
      background: $blue-grey80;
      border-top: 1px solid $blue-grey50;
      border-bottom: 1px solid $blue-grey50;

      &::before {
        display: none;
      }
    }

    &__params {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      row-gap: 16px;
      margin: 0 16px 16px;
    }

    &__param::after {
      display: none;
    }

    &__param {
      flex-direction: row;
      width: 100%;
      align-items: flex-start;
      padding: 0;
      margin: 0;
    }

    &__param-icon {
      width: 24px;
      min-width: 24px;
      height: 24px;
      margin-right: 8px;
    }

    &__param-info {
      text-align: left;
    }
  }

  @media (max-width: $breakpointHeaderMobile) {
    &__top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 12px 16px 0;

      &-actions {
        position: relative;
        display: flex;
        justify-content: flex-end;
        margin-top: 0;
        top: 0;
        right: 0;
      }
    }

    &__breadcrumbs.breadcrumbs {
      position: static;
      padding-right: 0;
      margin: 0;

      .--tournament.--state-open & {
        padding-right: 0;
      }

      .breadcrumbs__item {
        margin-bottom: 0;
        line-height: 18px;
      }
    }

    .add-to-calendar {
      margin-right: 8px;
    }

    .social-share {
      position: relative;
      top: 0;
      right: 0;
    }
  }

  @media (max-width: $breakpointMobile) {
    &__info {
      padding-top: 40px;
    }

    &__when {
      flex-wrap: wrap;

      &-date {
        margin-left: 8px;
      }
    }

    &__freeroll {
      margin-left: 8px;
    }

    &__title-right {
      width: 100%;
    }

    &__buttons {
      flex-direction: column;
      align-items: flex-start;
      width: 100%;

      .button {
        width: 100%;

        &.--club {
          width: auto;
        }

        &:not(:first-child) {
          margin: 16px 0 0;
        }
      }
    }

    &__game-account {
      position: static;
    }

    &__time-wrap {
      display: none;
    }

    &__date-info {
      height: auto;
    }

    &__params {
      grid-template-columns: 1fr 1fr;
    }

    &__param-icon {
      margin-right: 8px;
    }
  }

  &__litres {
    display: block;
    width: 100%;
    height: 42px;
    padding: 10px 16px;
    color: $white;
    background-color: #ff4c00;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    flex-shrink: 0;

    @media (min-width: 500px) {
      max-width: 210px;
      margin-right: 16px;
    }

    &-bold {
      display: inline-block;
      margin-right: 4px;
      font-weight: 800;
    }
  }
}
</style>
